import React from "react";
import { fw400, primaryTextColor, titleS } from "../../../Global.module.css";
import styles from "./IconTextButton.module.css";

export default function IconTextButton({ text, icon, action }) {
	const deleteButton = text === "Delete" ? styles.delete : "";
	return (
		<button
			className={`${styles.iconTextButton}`}
			onClick={!action ? null : action}
		>
			<img src={icon} alt={text} />
			<p
				className={`${titleS} ${fw400} ${primaryTextColor} ${deleteButton} ${styles.text}`}
			>
				{text}
			</p>
		</button>
	);
}
